/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { serverUrl } from "../../../../serverUrl"
import { useParams } from "react-router-dom"

export default function PropertySideMetrics({ numberOfOccupiedHouses, houseLength, selectedProperty }) {
    const [accountNumbers, setAccountNumber] = useState('')
    const { id } = useParams()
    const accessToken = localStorage.getItem("authTokens");
    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const config = {
        headers: { Authorization: `Bearer ${access}` }
    }
    useEffect(() => {
        serverUrl.get(`/landlord/landlord-name-in-apartment/?apartment_id=${id}`, config)
            .then((res) => {
                setAccountNumber(res.data.count)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])
    return (
        <div className="bg-white rounded-lg shadow p-4 mb-4">
            <div className="font-bold text-base text-left text-green-500 border-b pb-2 mb-4">
                METRICS
            </div>
            <div className="space-y-4">
                {/* Units */}
                <div className="flex justify-between items-center">
                    <span>Units</span>
                    <span className="text-green-500 font-bold">[{houseLength}]</span>
                </div>
                {/* Accounts */}
                <div className="flex justify-between items-center">
                    <span>Accounts</span>
                    <span className="text-green-500 font-bold">[{accountNumbers}]</span>
                </div>
                {/* Amenities */}
                {/* <div className="flex justify-between items-center">
                    <span>Amenities</span>
                    <span className="text-green-500 font-bold">[{amenitiesApartment.length}]</span>
                </div> */}
                {/* Tenants */}
                <div className="flex justify-between items-center">
                    <span>Tenants</span>
                    <span className="text-green-500 font-bold">[{numberOfOccupiedHouses}]</span>
                </div>
                {/* USSD */}
                <div className="flex justify-between items-center">
                    <span>USSD</span>
                    <span className="text-green-500 font-bold">{selectedProperty?.results[0].ussd}</span>
                </div>
            </div>
        </div>
    )
}